<div>
  <h2 mat-dialog-title class="primary-color" style="display: flex; justify-content: center; align-items: center;">{{tittle}}</h2>
  <mat-icon class="secondary-fill"
            svgIcon="close"
            style="width: 10%; float: right; margin-top: -50px; position: relative; cursor: pointer"
            (click)="onClose()"></mat-icon>
</div>
<div mat-dialog-content>
  <form [formGroup]="myForm" class="login-form-container light-22px-center-white" style="width: 100% !important; display: flex; justify-content: left; flex-direction: column;"
  (ngSubmit)="onSubmit()">

    <label [for]="'email'" class="primary-color" style="margin-right: 0px; font-size: 16px; width: 100%; text-align: center; font-weight: bold;">
      Bonos en pulsera </label>
      @for (voucher of actualVouchers; track voucher) {
      <div class="primary-color" style="padding-top: 10px; font-size: 14px !important; display: flex;
      justify-content: center">
        <div style="display: flex; justify-content:space-between; width: 300px">
          <span style="display: flex; align-items: center;"><strong>{{ 'dataBase.voucher' | translate }}: </strong> {{voucher.name}}</span>
          <mat-form-field style="text-align: center; width: 125px;">
            <input type="number"
                  min= "0"
                  class="form-control"
                  [formControl]="usesArray.controls[$index]"
                  matInput
                  placeholder="Usos Restantes: {{voucher.usesLeft.split('.')[0]}}  ">
          </mat-form-field>
        </div>
      </div>
      }

      <label [for]="'email'" class="primary-color" style="margin-top: 40px; font-size: 16px; width: 100%; text-align: center; font-weight: bold;">
        Añadir bonos a pulsera </label>
        @for (voucherNew of eventVouchers; track voucherNew) {
        <div class="primary-color" style="padding-top: 10px; font-size: 14px !important; display: flex;
        justify-content: center">
          <div style="display: flex; justify-content:space-between; width: 300px">
            <span style="display: flex; align-items: center;"><strong>{{ 'dataBase.voucher' | translate }}: </strong> {{voucherNew.name}}</span>
            
            <input type="checkbox"
                    class="form-control"
                    [formControl]="usesArrayNew.controls[$index]"
                    placeholder="Usos bono: {{voucherNew.uses}}  ">
          </div>
        </div>
        }
  </form>
</div>

<div mat-dialog-actions style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 10px;">

  <button class="secondary"
          [class.disabled]="!myForm.valid"
          mat-button
          (click)="onSubmit()">{{saveText}}</button>
</div>


